import { yupResolver } from '@hookform/resolvers/yup';
import { DialogTitle, DialogContent, Grid } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledTextInput, WsButton } from 'wisestep-base';
import { object, string } from 'yup';

interface TemplateProps {
  getName: (d: string) => void;
  close(): void;
  templateName: string;
}

interface tempSaveProps {
  name: string;
}
const SaveTemplateDialog = ({ getName, close, templateName }: TemplateProps) => {
  const validationSchema = object().shape({
    name: string().required('Template Name is required'),
  });
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: {
      name: templateName,
    },
  };
  const methods = useForm<tempSaveProps>(formOptions);
  return (
    <FormProvider {...methods}>
      <DialogTitle
        sx={{
          justifyContent: 'center',
        }}
      >
        Save Template
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          component="form"
          onSubmit={methods.handleSubmit((t) => getName(t.name))}
          spacing={2}
        >
          <Grid item xs={12}>
            <ControlledTextInput
              fullWidth
              name="name"
              placeholder="Template name"
              type="text"
              required
            ></ControlledTextInput>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="end" container>
            <WsButton onClick={close} size="large">
              Cancel
            </WsButton>
            <WsButton type="submit" size="large">
              Save
            </WsButton>
          </Grid>
        </Grid>
      </DialogContent>
    </FormProvider>
  );
};
export default SaveTemplateDialog;
